import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Form, Page } from "@cc/react-components";

interface Props extends React.HTMLAttributes<HTMLElement> {
  freePosology: string;
  setFreePosology: (text: string) => void;
  isValid: boolean;
}

const MedicationPosologyFree = ({
  freePosology,
  setFreePosology,
  isValid,
}: Props) => {
  const [t] = useTranslation();
  const [touched, setTouched] = useState(false);

  const isInvalidCheck = () => {
    return touched ? !isValid : false;
  };

  return (
    <Page>
      <Page.Body>
        <Page.Title className="font-weight-bold">
          {t("medicationFlow.posologyFreeText")}
        </Page.Title>
        <Form>
          <Form.Group>
            <Form.Textarea
              rows={6}
              placeholder={t("medicationFlow.posologyFreeTextPlaceholder")}
              isInvalid={isInvalidCheck()}
              defaultValue={freePosology}
              onChange={(e) => {
                setTouched(true);
                setFreePosology(e.target.value);
              }}
            />
            <Form.Feedback type="invalid">{t("error.required")}</Form.Feedback>
          </Form.Group>
        </Form>
      </Page.Body>
    </Page>
  );
};

export default MedicationPosologyFree;
